import { ACTIONS } from '../const';

export default function(state = null, action) {
    if (action.type === ACTIONS.CURRENT_TERM) {
        return action.payload;
    }

    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/current_term.js